import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { User, UserBackoffice, Video } from '../shared/interfacce.model';

@Injectable({
  providedIn: 'root',
})
export class StorageService {

  TOKEN_KEY = '7live-auth-token';
  TOKEN_BACKOFFICE_KEY = '7live-auth-token-backoffice';
  USER_KEY = '7live-auth-user';
  USER_BACKOFFICE_KEY = '7live-auth-user-backoffice';

  COOKIE_KEY = '7live-cookies';
  VIDEO_KEY = '7live-videos';

  UserChanged = new Subject<{id: number, nome: string, cognome: string, email: string} | null>();    

  constructor() {}

  getToken(): string {    
    return localStorage.getItem(this.TOKEN_KEY) || '';
  }

  getTokenBackoffice(): string {    
    return localStorage.getItem(this.TOKEN_BACKOFFICE_KEY) || '';
  }

  getUser(): User {
    let user = localStorage.getItem(this.USER_KEY);           
    return user ? JSON.parse(user) : '';
  }

  getUserBackoffice(): UserBackoffice {
    let user = localStorage.getItem(this.USER_BACKOFFICE_KEY);           
    return user ? JSON.parse(user) : '';
  }

  getCookie(): string {    
    return localStorage.getItem(this.COOKIE_KEY) || '';
  }

  getVideo(): Video[] {    
    let video = localStorage.getItem(this.VIDEO_KEY);
    return video ? JSON.parse(video) : [];
  }

  setToken(token: string): void {
    localStorage.removeItem(this.TOKEN_KEY);
    localStorage.setItem(this.TOKEN_KEY, token);    
  }  

  setTokenBackoffice(token: string): void {
    localStorage.removeItem(this.TOKEN_BACKOFFICE_KEY);
    localStorage.setItem(this.TOKEN_BACKOFFICE_KEY, token);
  }  

  setUser(utente: {id: number, nome: string, cognome: string, email: string}): void {
    localStorage.removeItem(this.USER_KEY);
    localStorage.setItem(this.USER_KEY, JSON.stringify(utente));            
    this.UserChanged.next(utente);
  }

  setUserBackoffice(utente: {id: number, username: string, tipo: string, id_canale: number}): void {
    localStorage.removeItem(this.USER_BACKOFFICE_KEY);
    localStorage.setItem(this.USER_BACKOFFICE_KEY, JSON.stringify(utente));    
  }

  setCookie(cookie: string): void {
    localStorage.removeItem(this.COOKIE_KEY);
    localStorage.setItem(this.COOKIE_KEY, cookie);    
  }  

  setVideo(video: Video[]): void {
    localStorage.removeItem(this.VIDEO_KEY);
    localStorage.setItem(this.VIDEO_KEY, JSON.stringify(video));    
  }

  clearUser(): void {
    localStorage.removeItem(this.USER_KEY);
    localStorage.removeItem(this.TOKEN_KEY);
    this.UserChanged.next(null);
  }

  clearUserBackoffice(): void {
    localStorage.removeItem(this.USER_BACKOFFICE_KEY);
    localStorage.removeItem(this.TOKEN_BACKOFFICE_KEY);
  }

  clearCookie(): void {
    localStorage.removeItem(this.COOKIE_KEY);    
  }

  clearVideo(): void {
    localStorage.removeItem(this.VIDEO_KEY);    
  }

  clearStorage(): void {    
    localStorage.clear();
  }
}